import styled from "styled-components";

export const ModeStyle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 5px;
  left: 100px;
  padding: 0.5rem;
  /* background-color: ${({ bgColor }) => bgColor}; */
  border: ${({ border }) => `3px solid ${border}`};
  cursor: pointer;
  border-radius: 50%;
  transition: 0.4s all ease-in-out;
`;
